import { ANALYZE, RESTART, START, STATUS } from 'Config/Paths';
import { AnalyticsEtlMetadata, GetEmbedUrlResponse } from 'Models/Analytics';
import { ResponseModel } from 'Models/ResponseModel';
import { restApiGet, restApiPost } from 'RestApiConnector';

import { AnalyticsApi } from './AnalyticsApi';

export class AWSAnalyticsApi implements AnalyticsApi {
    getEmbedUrl = (): Promise<ResponseModel<GetEmbedUrlResponse>> => {
        return restApiGet(`/${ANALYZE}`);
    };

    getEtlMetadata = (): Promise<ResponseModel<AnalyticsEtlMetadata>> => {
        return restApiGet(`/${ANALYZE}/${STATUS}`);
    };

    requestEtl = (): Promise<ResponseModel<AnalyticsEtlMetadata>> => {
        return restApiPost(`/${ANALYZE}/${START}`, {});
    };

    resetAnalysis = (): Promise<ResponseModel<void>> => {
        return restApiPost(`/${ANALYZE}/${RESTART}`, {});
    };
}
